// extracted by mini-css-extract-plugin
module.exports = {"main":"svg_main__AaSwX"};